import PropTypes from 'prop-types';
import React from 'react';
import { ButtonStyled } from './ButtonStyled';

const ButtonControl = (props) => {
  return (
    <ButtonStyled>
      <button data-test={props?.dataTest} disabled={props?.btnDisabled} className={props?.variant} type="submit" onClick={props.onClick}>
        <span className="icon"></span>
        {props?.label}
      </button>
    </ButtonStyled>
  );
};

ButtonControl.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  btnDisabled: PropTypes.bool,
  dataTest: PropTypes.string
};

ButtonControl.defaultProps = {
  label: '',
  variant: 'primary',
  btnDisabled: false,
  dataTest: ''
};

export default ButtonControl;
